export enum TelephoneTypeLieuEnum {
  PRINCIPALE = 'RESIDENCE_PRINCIPALE',
  SECONDAIRE = 'AUTRE',
  TRAVAIL = 'LIEU_TRAVAIL',
}
